module.exports = __webpack_public_path__ + "static/media/volume.de76b79f.svg";